import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Overlay from '../../../components/overlay/Overlay';

import {
  closeOverlay
} from '../../../modules/overlay/actions';

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onDismiss: closeOverlay
  }, dispatch);
}

function mapStateToProps(state) {
  const betslipVisibility = state.getIn(['betslip', 'betslipVisible']);
  const rightSidebarVisibility = window.innerWidth < 1200 ? state.getIn(['rightSidebar', 'visible']) : false;
  const navigationPanelVisibility = state.getIn(['navigation', 'panelVisibility']);
  const overlayVisibility = state.getIn(['overlay', 'visible']);

  const isVisible =
    betslipVisibility
    || rightSidebarVisibility
    || navigationPanelVisibility
    || overlayVisibility;

  return {
    isVisible
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Overlay);
